import { Component, OnInit, computed, output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';

export interface RegisterSubmitPayload {
  authorizationCode: string;
  emailAddress: string;
  groupSpecifiedIdentifier: string;
  subGroupSpecifiedIdentifier: string;
  agencyTin: string;
  agentSsn: string;
}

@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.scss'],
    standalone: false
})
export class RegisterComponent implements OnInit {
  constructor(private readonly fb: UntypedFormBuilder, private readonly route: Router,
              private readonly activatedRoute: ActivatedRoute) {
  }

  registerForm: UntypedFormGroup;
  readonly queryParams = toSignal(this.activatedRoute.queryParams, {
    initialValue: this.activatedRoute.snapshot.queryParams
  });
  readonly groupAssocLevel = computed(() => this.queryParams()?.['lvl'] === 'groupAssocLevel');
  readonly groupLevel = computed(() => this.queryParams()?.['lvl'] === 'groupLevel');
  readonly subgroupLevel = computed(() => this.queryParams()?.['lvl'] === 'subgroupLevel');
  readonly agencyLevel = computed(() => this.queryParams()?.['lvl'] === 'agencyLevel');
  readonly independentAgent = computed(() => this.queryParams()?.['lvl'] === 'independentAgent');
  readonly error = computed(() => !(this.groupAssocLevel() || this.groupLevel() || this.subgroupLevel() || this.agencyLevel() || this.independentAgent())
    ? 'Please use the link provided in your registration email. Please try again or retype the webpage address.'
    : '');
  readonly registerSubmit = output<RegisterSubmitPayload>();


  ngOnInit(): void {
    this.registerForm = this.fb.group({
      authorizationCode: ['', Validators.required],
      emailAddress: ['', [Validators.required, Validators.maxLength(100), Validators.pattern('^[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,}$')]],
      groupSpecifiedIdentifier: [{ value: '', disabled: this.agencyLevel() || this.independentAgent() }, Validators.required],
      subGroupSpecifiedIdentifier: [{ value: '', disabled: !this.subgroupLevel() }, Validators.required],
      agencyTin: [{ value: '', disabled: !this.agencyLevel() }, [Validators.required, Validators.minLength(9)]],
      agentSsn: [{ value: '', disabled: !this.independentAgent() }, [Validators.required, Validators.minLength(9)]]
    });
  }

}
